module.exports = __webpack_public_path__ + "img/backspace.6cf43fa2.svg";